'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _hammerjs = require('hammerjs');

var _hammerjs2 = _interopRequireDefault(_hammerjs);

require('../../../@Neptune/scripts/_n');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Stepper = {
	init: function init() {

		_n.qsa('.stepper').forEach(function (el) {
			var MC = new _hammerjs2.default(el);
			var counter = _n.qs(".counter", el);
			var arrowUp = _n.qs(".arrowup", el);
			var arrowDown = _n.qs(".arrowdown", el);
			var count = parseInt(_n.qs("[data-count]", el).getAttribute('data-count'));
			var min = parseInt(_n.qs("[data-min]", el).getAttribute('data-min'));
			var max = parseInt(_n.qs("[data-max]", el).getAttribute('data-max'));
			var input = _n.qs("input", el);

			MC.get('pan').set({ threshold: 0, direction: _hammerjs2.default.DIRECTION_VERTICAL });

			function calc(v) {
				return 10 * Math.sign(v) * Math.log10(1 + Math.abs(v));
			}

			MC.on('pan', function (ev) {
				el.style.transitionDuration = '0s';
				el.style.transform = 'rotate(' + calc(ev.deltaY) + 'deg)';

				var op = 1 - Math.log10(1 + Math.abs(ev.deltaY)) / 2;
				if (Math.sign(ev.deltaY) < 0) {
					arrowUp.style.opacity = op;
				} else {
					arrowDown.style.opacity = op;
				}
			});

			MC.on('panend', function (ev) {
				el.style.transitionDuration = '.4s';
				el.style.transform = 'none';
				arrowUp.style.opacity = 1;
				arrowDown.style.opacity = 1;
				if (Math.abs(ev.deltaY) >= 30) {
					var dir = Math.sign(ev.deltaY) * -1;
					if (count + dir < min || count + dir > max) return false;
					count += dir;
					counter.innerText = count;
					input.value = count;
					counter.classList.add(dir < 0 ? 'anim-up' : 'anim-down');
					setTimeout(function () {
						counter.classList = 'counter';
						counter.dataset.count = count;
					}, 350);
				}
			});
			window.addEventListener('scroll', function () {
				el.style.transform = 'rotate(0deg)';
				arrowUp.style.opacity = 1;
				arrowDown.style.opacity = 1;
			});
		});
	}
};

window.Stepper = Stepper;
exports.default = Stepper;